<template>
  <div>
    <CommonHead></CommonHead>
    <div class="signup">
      <b-jumbotron class="pl-0 pr-0" container-fluid="true" bg-variant="white">
        <b-container fluid>
          <b-row>
            <b-col class="pl-0 pr-0" cols="5">
              <b-img src="/shop/images/siginimage.jpg" fluid alt="Fluid image"></b-img>
              <div class="signin_div">
                <h1>Welcome Back!</h1>
                <p>
                  Enter your details and
                  <br />sign in to your account.
                </p>
                <b-button href="/shop/login" block variant="dark" squared>Sign In</b-button>
              </div>
            </b-col>
            <b-col>
              <div class="register-form">
                <h1>Apply for New Account</h1>
                <p class="info_note">Complete the form below for online access and ordering.</p>
                <div class="sign_up">
                  <b-form class="commonform" @submit="onSubmit">
                    <b-row>
                      <b-col>
                        <md-field :state="!form.errors.has('firstname')" :class="form.errors.get('firstname')?'haserror forstar':'forstar'"
                            :invalid-feedback="form.errors.get('firstname')">
                          <label>First Name</label>
                          <md-input :state="!form.errors.has('firstname')"
                                @input="form.errors.clear('firstname')" v-model="form.firstname" type="text"></md-input>
                          <span class="error-msg" v-if="form.errors.get('firstname')">Required Field</span>
                        </md-field>
                      </b-col>
                      <b-col>
                        <md-field :state="!form.errors.has('lastname')" :class="form.errors.get('lastname')?'haserror forstar':'forstar'"
                            :invalid-feedback="form.errors.get('lastname')">
                          <label>Last Name</label>
                          <md-input :state="!form.errors.has('lastname')"
                                @input="form.errors.clear('lastname')" v-model="form.lastname" type="text"></md-input>
                          <span class="error-msg" v-if="form.errors.get('lastname')">Required Field</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field :state="!form.errors.has('email')" :class="form.errors.get('email')?'haserror forstar':'forstar'"
                            :invalid-feedback="form.errors.get('email')">
                          <label>Email</label>
                          <md-input :state="!form.errors.has('email')"
                                @input="form.errors.clear('email')" v-model="form.email" type="email"></md-input>
                          <span class="error-msg" v-if="form.errors.get('email')">{{form.errors.get('email')=="The email field is required."?'Required Field':form.errors.get('email')}}</span>
                        </md-field>
                      </b-col>
                      <b-col>
                        <md-field :state="!form.errors.has('password')" :class="form.errors.get('password')?'haserror forstar':'forstar'"
                            :invalid-feedback="form.errors.get('password')">
                          <label>Password</label>
                          <md-input :state="!form.errors.has('password')"
                                @input="form.errors.clear('password')" v-model="form.password" type="password"></md-input>
                                <span class="error-msg" v-if="form.errors.get('password')">{{form.errors.get('password')=="The password field is required."?'Required Field':form.errors.get('password')}}</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="6">
                        <md-field>
                          <label>Company Name</label>
                          <md-input v-model="form.companyname" type="text"></md-input>
                        </md-field>
                      </b-col>
                      <b-col cols="4">
                        <md-field :state="!form.errors.has('phoneno')" :class="form.errors.get('phoneno')?'haserror forstar':'forstar'"
                            :invalid-feedback="form.errors.get('phoneno')">
                          <label>Phone No.</label>
                          <md-input :state="!form.errors.has('phoneno')"
                                @input="form.errors.clear('phoneno')" v-model="form.phoneno" type="number"></md-input>
                          <span class="error-msg" v-if="form.errors.get('phoneno')">Required Field</span>
                        </md-field>
                      </b-col>
                      <b-col cols="2">
                        <md-field :state="!form.errors.has('extenstion')" :class="form.errors.get('extenstion')?'haserror forstar':'forstar'"
                            :invalid-feedback="form.errors.get('extenstion')">
                          <label>Ext.</label>
                          <md-input :state="!form.errors.has('extenstion')"
                                @input="form.errors.clear('extenstion')" v-model="form.extenstion" type="number"></md-input>
                          <span class="error-msg" v-if="form.errors.get('extenstion')">Required Field</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field>
                          <label>Country Code</label>
                          <md-input v-model="form.countrycode" type="number"></md-input>
                        </md-field>
                      </b-col>
                      <b-col>
                        <md-field>
                          <label>Fax No.</label>
                          <md-input v-model="form.faxno" type="number"></md-input>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field :state="!form.errors.has('streetaddress')" :class="form.errors.get('streetaddress')?'haserror forstar':'forstar'"
                            :invalid-feedback="form.errors.get('streetaddress')">
                          <label>Street Address</label>
                          <md-input :state="!form.errors.has('streetaddress')"
                                @input="form.errors.clear('streetaddress')" v-model="form.streetaddress" type="text"></md-input>
                          <span class="error-msg" v-if="form.errors.get('streetaddress')">Required Field</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field :state="!form.errors.has('city')" :class="form.errors.get('city')?'haserror forstar':'forstar'"
                            :invalid-feedback="form.errors.get('city')">
                          <label>City</label>
                          <md-input :state="!form.errors.has('city')"
                                @input="form.errors.clear('city')" v-model="form.city" type="text"></md-input>
                          <span class="error-msg" v-if="form.errors.get('city')">Required Field</span>
                        </md-field>
                      </b-col>
                      <b-col>
                        <md-field :state="!form.errors.has('state')" :class="form.errors.get('state')?'haserror forstar':'forstar'"
                            :invalid-feedback="form.errors.get('state')">
                          <label>State</label>
                          <md-input :state="!form.errors.has('state')"
                                @input="form.errors.clear('state')" v-model="form.state" type="text"></md-input>
                          <span class="error-msg" v-if="form.errors.get('state')">Required Field</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field :state="!form.errors.has('country')" :class="form.errors.get('country')?'haserror forstar':'forstar'"
                            :invalid-feedback="form.errors.get('country')">
                          <label>Country</label>
                          <md-input :state="!form.errors.has('country')"
                                @input="form.errors.clear('country')" v-model="form.country" type="text"></md-input>
                          <span class="error-msg" v-if="form.errors.get('country')">Required Field</span>
                        </md-field>
                      </b-col>
                      <b-col>
                        <md-field :state="!form.errors.has('zipcode')" :class="form.errors.get('zipcode')?'haserror forstar':'forstar'"
                            :invalid-feedback="form.errors.get('zipcode')">
                          <label>Zip Code</label>
                          <md-input :state="!form.errors.has('zipcode')"
                                @input="form.errors.clear('zipcode')" v-model="form.zipcode" type="number"></md-input>
                          <span class="error-msg" v-if="form.errors.get('zipcode')">Required Field</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field :state="!form.errors.has('accountnumber')" :class="form.errors.get('accountnumber')?'haserror forstar':'forstar'"
                            :invalid-feedback="form.errors.get('accountnumber')">
                          <label>Account No.</label>
                          <md-input :state="!form.errors.has('accountnumber')"
                                @input="form.errors.clear('accountnumber')" v-model="form.accountnumber" type="text"></md-input>
                          <span class="error-msg" v-if="form.errors.get('accountnumber')">{{form.errors.get('accountnumber')=="The accountnumber field is required."?'Required Field':form.errors.get('accountnumber')}}</span>
                        </md-field>
                      </b-col>
                      <b-col>
                        <md-field>
                          <label>Position</label>
                          <md-input v-model="form.position" type="text"></md-input>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-button type="submit" block variant="dark">Submit</b-button>
                  </b-form>
                </div>
                <div class="help_signup">
                  <p>Need Help with Sign up?</p>
                  <b-button href="/shop/contact" block variant="outline-primary" squared>Contact Us</b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-jumbotron>
    </div>
    <CommonFoot></CommonFoot>
  </div>
</template>

<script>
import AuthMixin from "../../mixins/auth";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";

export default {
  name: "ErrorsMessages",
  components: {
    CommonHead,
    CommonFoot
  },
  data() {
    return {
      form: {
        firstname: null,
        lastname: null,
        email: null,
        password: null,
        companyname: null,
        phoneno: null,
        extenstion: null,
        countrycode: null,
        faxno: null,
        streetaddress: null,
        city: null,
        state: null,
        country: null,
        zipcode: null,
        accountnumber: null,
        position: null
      },
      show: true
    };
  },
  //mixins: [ResourceMixin],
  beforeMount() {
    this.initForm();
  },
  computed: {
    //...mapGetters(["leadHotel"])
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      //this.save();
    },
  initForm() {
    this.form = new Form({
      firstname: null,
      lastname: null,
      email: null,
      password: null,
      companyname: null,
      phoneno: null,
      extenstion: null,
      countrycode: null,
      faxno: null,
      streetaddress: null,
      city: null,
      state: null,
      country: null,
      zipcode: null,
      accountnumber: null,
       position: null
    });
  },
  save() {
    this.$store
      .dispatch("registerRequest", {
        token: this.$route.query.token,
        form: this.form
      })
      .then(() => {
        this.$notify({
          text: "Thank you, we will email you shortly",
          type: "success"
        });
        this.$router.push("/shop/login");
      })
      .catch(error => {
        if (this.form.hasErrors()) {
          this.$notify({
            text:
              "There is a validation error. Please correct the fields outlined in red and try again.",
            type: "error"
          });
        } else {
          this.$notify({
            text: "Something went wrong!",
            type: "error"
          });
        }
      });
  }
   }
};
</script>
<style>
.signup {
  width: 100%;
  overflow: hidden;
}
.signup .bg-white {
  padding-top: 0;
  padding-bottom: 0;
  margin-bottom: 0;
}
.signup .sign_up .commonform .row {
  margin: 0 -10px;
}
.signup .sign_up .commonform .col,
.signup .sign_up .commonform .col-6,
.signup .sign_up .commonform .col-4,
.signup .sign_up .commonform .col-2 {
  padding: 0 10px;
}
.signup .img-fluid {
  height: 1045px;
  object-fit: cover;
  width: 100%;
}
.signup .pr-0.col-5.pl-0 {
  max-width: 43.5%;
  flex: 0 0 43.5%;
}
.signin_div {
  position: absolute;
  background: rgba(210, 210, 210, 0.9);
  top: 15%;
  left: 50%;
  transform: translate(-50%, 0);
  width: 435px;
  height: 355px;
  text-align: center;
  padding: 20px 60px;
  box-sizing: border-box;
}
.signin_div h1 {
  padding-top: 80px;
  margin-bottom: 25px;
}
.signin_div p {
  font-size: 14px;
  color: #303030;
}
.signin_div .btn-dark {
  background: #303030;
  color: #fff;
  height: 45px;
  line-height: 37px;
  text-transform: uppercase;
  font-family: "Spartan", sans-serif;
  margin-top: 40px;
  font-size: 12px;
}
.register-form {
  max-width: 790px;
  width: 100%;
  margin: 0;
  padding: 0 0 0 50px;
  box-sizing: border-box;
  position: relative;
}
.register-form h1 {
  margin-top: 40px;
  display: inline-block;
  width: 100%;
  margin-bottom: 20px;
  line-height: 32px;
}
.register-form p.info_note{
	text-align:center;
	margin-bottom:20px;
}
.sign_up .md-field {
  margin-bottom: 16px;
}
.commonform .md-field.md-focused label,
.commonform .md-field.md-has-value label,
.commonform .md-field label {
  pointer-events: auto;
  top: 8px;
  opacity: 1;
  left: 15px;
  background: #fff;
  padding: 0 5px;
  font-weight: 400;
  font-size: 12px;
  color: #777777;
}
.commonform .md-field .md-input,
.commonform .md-field .md-textarea {
  border: 1px solid #d2d2d2;
  height: 43px;
  border-radius: 3px;
  width: 100%;
  padding: 10px 10px 10px 20px;
  box-sizing: border-box;
  font-size: 12px !important;
  overflow: hidden;
  color: #303030;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.commonform .md-field.forstar label:after {
  font-size: 16px;
  color: red;
  right: 10px;
  position: absolute;
  top: 2px;
  transform: translateX(calc(100% + 2px));
  content: "*";
  line-height: 1em;
  vertical-align: top;
}
/* .sign_up .btn-block {
  background: #303030;
  color: #fff;
  height: 35px;
  line-height: 28px;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 12px;
  margin-top: 14px;
} */
.help_signup {
  margin-top: 60px;
}
.help_signup p {
  font-size: 16px;
  font-weight: 500;
  color: #303030;
  text-align: center;
}
.help_signup .btn.btn-outline-primary {
  max-width: 150px;
  margin: 12px auto 0 auto;
}
@media only screen and (max-width: 1440px) {
  .register-form {
  max-width: 725px;
  padding: 0px 0 0 40px;
  }
}
@media only screen and (max-width: 1367px){
.register-form {
    max-width: 725px;
    padding: 0px 0 0 10px;
}
}
@media only screen and (max-width: 1199px) and (min-width: 1025px) {
  .login .login-form{
    margin-right: 80px;
  }
}
@media only screen and (max-width:1024px) and (min-width:768px){
.register-form{padding:0;}
	.signup .container-fluid .row .col{
		order:1;
	}
	.signup .pr-0.col-5.pl-0 {
		max-width: 100%;
		-webkit-box-flex: 0;
		flex: 100%;
		order:2;
	}
	.login .pr-0.col-5.pl-0 {
		max-width: 100%;
		-webkit-box-flex: 0;
		flex: 100%;
	}
	.register-form{
		max-width:100%;
	}
	.login .login-form {
		max-width: 420px;
		float: none;
		width: 100%;
		margin: 0 auto;
	}
	.login .login-form h1{
		margin-top:60px;
	}
	.signin_div{
		width:58%;
		top:23%;
	}
	.login .img-fluid,.signup .img-fluid{
		height:590px;
		margin-top:60px;
	}
	footer .footmenu{
		flex-wrap:wrap;
	}
}
@media only screen and (max-width:767px){	
  .register-form{padding:0;}
  .signin_div h1 {
    padding-top: 40px;
  }
	.signup .container-fluid .row .col{
		flex-basis:100%;
		order:1;
	}
	.signup .pr-0.col-5.pl-0 {
		max-width: 100%;
		-webkit-box-flex: 0;
		flex: 100%;
		order:2;
	}
	.login .pr-0.col-5.pl-0 {
		max-width: 100%;
		-webkit-box-flex: 0;
		flex: 100%;
	}
	.register-form{
		max-width:100%;
	}
	.login .login-form {
		max-width: 100%;
		float: none;
		width: 100%;
		margin-right: 0;
	}
	.login .login-form h1{
		margin-top:60px;
	}
	.signin_div{
		width:85%;
		top:23%;
	}
	.login .img-fluid,.signup .img-fluid{
		height:auto;
		margin-top:60px;
	}
}
</style>